import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`

export const Content = styled.main`
  position: relative;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
`
